// extracted by mini-css-extract-plugin
module.exports = {"container":"_23lfd2b-3la8k4gtmdWNxs"};